export const FETCH_LEVELS_REQUEST = 'FETCH_LEVELS_REQUEST';
export const FETCH_LEVELS_SUCCESS = 'FETCH_LEVELS_SUCCESS';
export const FETCH_LEVELS_FAILED = 'FETCH_LEVELS_FAILED';
export const FETCH_VIDEOS_REQUEST = 'FETCH_VIDEOS_REQUEST';
export const FETCH_VIDEOS_SUCCESS = 'FETCH_VIDEOS_SUCCESS';
export const FETCH_VIDEOS_FAILED = 'FETCH_VIDEOS_FAILED';
export const SELECTED_LEVEL = 'SELECTED_LEVEL';
